import restapi from 'utils/restapi';
import {addLang} from "utils/addLang";

import { baseErrorsHandlerDecorator } from 'redux/utils';

import {
  GET_THEMES_LIST_SUCCESS,
  GET_THEMES_LIST_ERROR,
  CLEAR_GET_THEMES_LIST,
  PATCH_CUSTOM_THEME_SUCCESS,
  PATCH_CUSTOM_THEME_ERROR,
  CLEAR_PATCH_CUSTOM_THEME,
  REPLICATE_EXISTING_THEME_SUCCESS,
  REPLICATE_EXISTING_THEME_ERROR,
  CLEAR_REPLICATE_EXISTING_THEME,
} from 'redux/themes/types';


export const fetchThemesList = () => baseErrorsHandlerDecorator(
  GET_THEMES_LIST_SUCCESS,
  GET_THEMES_LIST_ERROR,
  () => restapi.get(addLang('users/themes/')),
  false,
);

export const clearThemesList = () => dispatch => {
  dispatch({
    type: CLEAR_GET_THEMES_LIST,
  });
};

export const patchCustomTheme = (themeId, formData) => baseErrorsHandlerDecorator(
  PATCH_CUSTOM_THEME_SUCCESS,
  PATCH_CUSTOM_THEME_ERROR,
  () => restapi.patch(addLang(`users/custom_themes/${themeId}/`), formData),
  false,
  true /* actionSucces */,
);

export const clearPatchCustomTheme = () => dispatch => {
  dispatch({
    type: CLEAR_PATCH_CUSTOM_THEME,
  });
};

export const replicateExistingTheme = origin => baseErrorsHandlerDecorator(
  REPLICATE_EXISTING_THEME_SUCCESS,
  REPLICATE_EXISTING_THEME_ERROR,
  () => restapi.post(addLang('users/replicate-theme/'), { origin }),
  false,
  true,
);

export const clearReplicateExistingTheme = () => dispatch => {
  dispatch({
    type: CLEAR_REPLICATE_EXISTING_THEME,
  });
};
